"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetFeature = void 0;
exports.getQuiltAssetURL = getQuiltAssetURL;
exports.getQuiltAssetNameAndLastModifiedFromURL = getQuiltAssetNameAndLastModifiedFromURL;
exports.urlWithTime = urlWithTime;
exports.default = getFilenameForAssetUpload;
const SwitchBranchHelper_1 = require("@aurora/shared-utils/helpers/developer/SwitchBranchHelper");
const ThemeAssetHelper_1 = require("@aurora/shared-utils/helpers/theme/ThemeAssetHelper");
const UrlBuilder_1 = __importDefault(require("@aurora/shared-utils/helpers/urls/UrlHelper/UrlBuilder"));
const UrlHelper_1 = require("@aurora/shared-utils/helpers/urls/UrlHelper/UrlHelper");
const path_to_regexp_1 = require("path-to-regexp");
const TimestampHelper_1 = __importDefault(require("./TimestampHelper"));
var AssetFeature;
(function (AssetFeature) {
    AssetFeature["QUILTS"] = "quilts";
    AssetFeature["QUILT_WRAPPERS"] = "quiltwrappers";
})(AssetFeature || (exports.AssetFeature = AssetFeature = {}));
// /t5/s/bobcat/m_assets/quilts/CommunityPage/node-navigation.jpg?assets.branch=main&time=1679530592000
const ASSET_URL = '/:contextName?/:servicePathChar?/:community?/m_assets/:assetFeature/:pageName/:assetName';
const quiltAssetUrlMatchCallback = (0, path_to_regexp_1.match)(ASSET_URL, {
    decode: decodeURIComponent,
    start: false
});
const quiltAssetUrlPathCallback = (0, path_to_regexp_1.compile)(ASSET_URL, {
    encode: UrlHelper_1.safeEncodeUriComponent
});
/**
 * Returns the fully-qualified url for a given quilt id and asset name
 *
 * @param tenant the current tenant
 * @param pageName the page name, aka. the quilt ID
 * @param assetName the asset name
 * @param assetFeature the asset feature.
 * @param timestamp whether the url should contain a timestamp as query parameter or not
 * @param branchName if not on the main branch, the branch name
 */
function getQuiltAssetURL(tenant, pageName, assetName, assetFeature, timestamp, branchName) {
    var _a;
    if (pageName && assetName) {
        const { community, liaContextPath } = tenant;
        const [, contextName, servicePathChar] = (_a = liaContextPath === null || liaContextPath === void 0 ? void 0 : liaContextPath.split('/')) !== null && _a !== void 0 ? _a : [];
        const basePath = (0, ThemeAssetHelper_1.buildBasePath)(quiltAssetUrlPathCallback, {
            contextName,
            servicePathChar,
            community,
            assetFeature,
            pageName,
            assetName
        });
        const url = UrlBuilder_1.default.fromUrl(basePath);
        if (process.env.NEXT_PUBLIC_URL_USE_HOST_IN_SERVLET_URL) {
            url.uri.host(tenant.host);
        }
        if (timestamp != null) {
            url.addQuery({ time: timestamp });
        }
        if ((0, SwitchBranchHelper_1.isCustomizationBranch)(tenant, branchName)) {
            url.addQuery({ 'assets.branch': branchName });
        }
        return url.build();
    }
    return null;
}
/**
 * Returns the asset name and last modified time from a given url
 *
 * @param tenant the current tenant
 * @param quiltId the quilt id
 * @param url the fully-qualified url for an asset
 */
function getQuiltAssetNameAndLastModifiedFromURL(tenant, quiltId, url) {
    var _a;
    if (url) {
        const { uri } = UrlBuilder_1.default.fromUrl(url);
        const matcher = quiltAssetUrlMatchCallback(uri.path());
        if (matcher) {
            const { assetName } = matcher.params;
            return { assetName, lastModified: (_a = uri.query().time) === null || _a === void 0 ? void 0 : _a.toString() };
        }
    }
    return null;
}
function urlWithTime(url, time) {
    const result = UrlBuilder_1.default.fromUrl(url);
    result.addQuery({ time: time.toString() });
    return result.build();
}
/**
 * Handling of spaces in filenames may be moved to LIA layer at some point -- TODO?
 */
function toFilename(rawFilename) {
    return rawFilename.replaceAll(' ', '_');
}
function getFilenameForAssetUpload(file, datetime = Date.now()) {
    return (0, TimestampHelper_1.default)(toFilename(file.name), datetime);
}
//# sourceMappingURL=AssetHelper.js.map